import { css } from '@emotion/react';

import { ZeeFontMedium } from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
import { flex } from '../../../../styles/utils';

export const container = css`
  z-index: 0;
  width: 100%;
  height: 100%;
`;

export const contentItemCard = css`
  height: 100%;
  ${flex('column', 'center', 'center')};
  ${MQ.MediaLg} {
    padding: 0 10px;
  }
`;
export const contentTitle = css`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #fff;
  cursor: pointer;
  display: -webkit-box;
  ${ZeeFontMedium(12, 16)}
  margin-top: 16px;
  max-height: 30px;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: center;
  ${MQ.MediaMd} {
    ${ZeeFontMedium(14, 18)}
  }
`;
